import { useFormikContext } from "formik"
import React from "react"
import { useTranslation } from "react-i18next"

import { AttachFileField } from "~/components/AttachFile/AttachFile"
import { Form } from "~/components/Form/Form"
import { FormSubmitSection } from "~/components/FormSubmitSection/FormSubmitSection"
import { Heading } from "~/components/Heading/Heading"
import { FormInput } from "~/components/Input/Input"
import { RadioBundle } from "~/components/RadioBundle/RadioBundle"
import { Raw } from "~/components/raw"
import { FormTextArea } from "~/components/TextArea/TextArea"

import styles from "./index.module.css"

const Content: React.FC = () => {
  const { t } = useTranslation()
  const { values } = useFormikContext<any>()
  const { project } = values

  // const radioItems = [
  //   {
  //     label: t("GrowBusiness.Buttons.invest"),
  //     name: "project",
  //     value: "invest",
  //   },
  //   {
  //     label: t("GrowBusiness.Buttons.suggest"),
  //     name: "project",
  //     value: "suggest",
  //   },
  // ]

  return (
    <>
      <Heading className={styles.Heading} like="h3">
        <Raw html={t("GrowBusiness.ContentPopupInvest.Heading")} />
      </Heading>

      <div className={styles.Description}>
        {/* {project === "invest" && (
          <p
            dangerouslySetInnerHTML={{
              __html: t("GrowBusiness.ContentPopupInvest.Description.Paragraph.04"),
            }}
          />
        )} */}

        {project === "suggest" && (
          <p
            dangerouslySetInnerHTML={{
              __html: t("GrowBusiness.ContentPopupInvest.Description.Paragraph.05"),
            }}
          />
        )}

        <Heading className={styles.Title} like="h4">
          <Raw html={t("GrowBusiness.ContentPopupInvest.Title")} />
        </Heading>

        <p
          dangerouslySetInnerHTML={{
            __html: t("GrowBusiness.ContentPopupInvest.Description.Paragraph.01"),
          }}
        />

        <p
          dangerouslySetInnerHTML={{
            __html: t("GrowBusiness.ContentPopupInvest.Description.Paragraph.02"),
          }}
        />

        <p
          dangerouslySetInnerHTML={{
            __html: t("GrowBusiness.ContentPopupInvest.Description.Paragraph.03"),
          }}
        />
      </div>

      <div className={styles.Form}>
        <Heading like="h4">
          <Raw html={t("GrowBusiness.Buttons.suggest")} />
        </Heading>

        {/* <RadioBundle items={radioItems} /> */}

        <FormInput label={t("popup.Default.Form.Phone.Label")} name="phone" />
        <FormInput label={t("popup.Default.Form.Email.Label")} name="email" />
        <FormInput label={t("popup.Default.Form.Fio.Label")} name="fio" />

        <RadioBundle />

        <FormTextArea label={t("popup.Default.Form.Message.Label")} name="message" />

        <AttachFileField />

        <FormSubmitSection className={styles.SendWrapper} />
      </div>
    </>
  )
}

export const ContentPopupInvest: React.FC<{ type: "invest" | "suggest" }> = ({ type }) => {
  return (
    <Form
      initialValues={{
        phone: "",
        email: "",
        fio: "",
        message: "",
        project: type,
        organisation: "organisation",
      }}
      url="/investmentsform/submit"
    >
      <Content />
    </Form>
  )
}
